import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useEffect, useState } from "react";
import { ToggleButton } from "@mui/material";
import "./Chart.scss";
import "../../../Sass/variable.scss";
import { homeChartData } from "../../../Recoil/atom";
import { useRecoilState } from "recoil";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Chart = (props) => {
  const [chartData, setChartData] = useRecoilState(homeChartData);
  const { yellow, labelColor, borderColor } = props;
  const [active, setActive] = useState("daily");
  const rootStyles = getComputedStyle(document.documentElement);
  const mainColor = rootStyles.getPropertyValue("--mainColor").trim();

  useEffect(() => {
    const storedSaleData = sessionStorage.getItem("PurchaseSaleChart");
    // console.log('chartDatachartData',chartData);
    if (chartData?.length == undefined) {
      if (storedSaleData) {
        setChartData(JSON.parse(storedSaleData)); 
      }
    }
  }, []); 

  const handleActive = (event, newActive) => {
    if (newActive !== null) { 
      setActive(newActive);
    }
  };

  const getChartData = () => {
    let data;
    let labels;
    let purchaseData;
    let saleData;

    switch (active) {
      case "daily":
        data = chartData?.DT || [];
        labels = data.map((item) => item.Day_Name);
        purchaseData = data.map((item) => item.PurchaseAmount);
        saleData = data.map((item) => item.SaleAmount);
        break;
        
      case "monthly":
        data = chartData?.DT2 || [];
        labels = data.map((item) => item.Month_Name);
        purchaseData = data.map((item) => item.PurchaseAmount);
        saleData = data.map((item) => item.SaleAmount);
        break;

      case "yearly":
        data = chartData?.DT3 || [];
        const currentYear = new Date().getFullYear();
        const cuu = currentYear - 1; // Get the last two digits of the next year
        const nextYearShort = (currentYear).toString().slice(-2); // Get the last two digits of the next year
        const fiscalYear = `${cuu}-${nextYearShort}`;
        labels = [`Year Total (${fiscalYear})`]; // Use dynamic fiscal year
        purchaseData = data.map((item) => item.PurchaseAmount);
        saleData = data.map((item) => item.SaleAmount);
        break;
      default:
        return { labels: [], datasets: [] };
    }

    return {
      labels,
      datasets: [
        {
          maxBarThickness: 15,
          label: "Purchase",
          backgroundColor: mainColor,
          borderColor: "transparent",
          data: purchaseData,
        },
        {
          maxBarThickness: 15,
          label: "Sale",
          backgroundColor: "rgb(255, 159, 67)",
          borderColor: "transparent",
          data: saleData,
        },
      ],
    };
  };

  const chartOptions = {
    indexAxis: "x",
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 500 },
    elements: {
      bar: {
        borderRadius: {
          topRight: 15,
          topLeft: 15,
        },
      },
    },
    layout: {
      padding: { top: -4 },
    },
    scales: {
      x: {
        grid: {
          drawTicks: false,
          color: borderColor,
        },
        ticks: { color: labelColor },
      },
      y: {
        min: 0,
        grid: {
          display: false,
          color: borderColor,
        },
        ticks: {
          color: labelColor,
          callback: function (value) {
            return value.toLocaleString("en-IN");
          },
        },
      },
    },
    plugins: {
      legend: {
        align: "end",
        position: "top",
        labels: { color: props.legendColor },
      },
    },
  };

  return (
    <div className="chart_main">
      <div>
        <div style={{ display: "flex", marginLeft: "15px" }}>
          <CardHeader
            sx={{
              flexDirection: ["column", "row"],
              alignItems: ["flex-start", "center"],
              "& .MuiCardHeader-action": { mb: 0 },
              "& .MuiCardHeader-content": { mb: [2, 0] },
            }}
            action={
              <ToggleButtonGroup
                exclusive
                value={active}
                onChange={handleActive}
              >
                <ToggleButton value="daily">Weekly</ToggleButton>
                <ToggleButton value="monthly">Monthly</ToggleButton>
                <ToggleButton value="yearly">Yearly</ToggleButton>
              </ToggleButtonGroup>
            }
            className="Chart_ToggleBtn"
          />
        </div>
        <CardContent>
          <Bar data={getChartData()} height={250} options={chartOptions} />
        </CardContent>
      </div>
    </div>
  );
};

export default Chart;




// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { Bar } from "react-chartjs-2";
// import Card from "@mui/material/Card";
// import CardHeader from "@mui/material/CardHeader";
// import CardContent from "@mui/material/CardContent";
// import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
// import "./Chart.scss";
// import { useEffect, useState } from "react";
// import { ToggleButton } from "@mui/material";
// import "../../../Sass/variable.scss";
// import { CommonAPImain } from "../../../../Utils/API/CommonAPImain/CommonAPImain";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// const Chart = (props) => {

//   const [chartData , setChartData] = useState();
//   const { yellow, labelColor, borderColor } = props;
//   const [active, setActive] = useState("daily");
//   const rootStyles = getComputedStyle(document.documentElement);
//   const mainColor = rootStyles.getPropertyValue("--mainColor").trim();

//   useEffect(() => {
//     CommonAPImain("Home_PurchaseSaleChart")
//       .then((response) => {
//         if (response?.Status == 200) {
//           console.log('response?.Data?.DT',response?.Data);
//           setChartData(response?.Data);
//         }
//       })
//       .catch((err) => console.log(err));

//   }, []);

//   const handleActive = (event, newActive) => {
//     setActive(newActive);
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     animation: { duration: 500 },
//     scales: {
//       x: {
//         grid: {
//           color: borderColor,
//         },
//         ticks: { color: labelColor },
//       },
//       y: {
//         min: 0,
//         max: 400,
//         grid: {
//           color: borderColor,
//         },
//         ticks: {
//           stepSize: 100,
//           color: labelColor,
//         },
//       },
//     },
//     plugins: {
//       legend: { display: false },
//     },
//   };

//   const data = {
//     labels: ["7/12", "8/12", "9/12", "10/12", "11/12", "12/12"],
//     datasets: [
//       {
//         maxBarThickness: 15,
//         backgroundColor: mainColor,
//         borderColor: "transparent",
//         borderRadius: { topRight: 15, topLeft: 15 },
//         data: [100, 90, 190, 205, 125, 85, 55, 87, 127, 150, 230, 280, 190],
//       },
//     ],
//   };

//   const { info, warning, labelColord, borderColord, legendColor } = props;

//   const optionsD = {
//     indexAxis: "x",
//     responsive: true,
//     maintainAspectRatio: false,
//     animation: { duration: 500 },
//     elements: {
//       bar: {
//         borderRadius: {
//           topRight: 15,
//           topLeft: 15,
//         },
//       },
//     },
//     layout: {
//       padding: { top: -4 },
//     },
//     scales: {
//       x: {
//         grid: {
//           drawTicks: false,
//           color: borderColor,
//         },
//         ticks: { color: labelColor },
//       },
//       y: {
//         min: 0,
//         grid: {
//           display: false,
//           color: borderColor,
//         },
//         ticks: { color: labelColor },
//       },
//     },
//     plugins: {
//       legend: {
//         align: "end",
//         position: "top",
//         labels: { color: legendColor },
//       },
//     },
//   };

//   const dataD = {
//     labels: ["MON", "TUE", "WED ", "THU", "FRI"],
//     datasets: [
//       {
//         maxBarThickness: 15,
//         label: "Sale",
//         backgroundColor: "rgb(255, 159, 67)",
//         borderColor: "transparent",
//         data: [100, 350, 320, 220, 120],
//       },
//       {
//         maxBarThickness: 15,
//         label: "Purchase",
//         backgroundColor: mainColor,
//         borderColor: "transparent",
//         data: [380, 350, 100, 240, 360],
//       },
//     ],
//   };

//   return (
//     <div>

//       <div className="chart_main">
//         <Card>
//           <div style={{ display: "flex", marginLeft: '15px'}}>
//             <CardHeader
//               sx={{
//                 flexDirection: ["column", "row"],
//                 alignItems: ["flex-start", "center"],
//                 "& .MuiCardHeader-action": { mb: 0 },
//                 "& .MuiCardHeader-content": { mb: [2, 0] },
//               }}
//               action={
//                 <ToggleButtonGroup
//                   exclusive
//                   value={active}
//                   onChange={handleActive}
//                 >
//                   <ToggleButton value="daily">Weekly</ToggleButton>
//                   <ToggleButton value="monthly">Monthly</ToggleButton>
//                   <ToggleButton value="yearly">Yearly</ToggleButton>
//                 </ToggleButtonGroup>
//               }
//               className="Chart_ToggleBtn"
//             />
//           </div>
//           <CardContent>
//             <Bar data={dataD} height={250} options={optionsD} />
//           </CardContent>
//         </Card>
//       </div>
//     </div>
//   );
// };

// export default Chart;
